var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"page historical-query"},[_c(_vm.currentComponent,{tag:"component",attrs:{"principalId":_vm.principalId,"groupType":_vm.groupType,"batchNumber":_vm.batchNumber},on:{"onClickBatchNumber":_vm.onClickBatchNumber,"onBackCollection":_vm.onBackCollection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }